import React, { Fragment, useEffect, useState } from 'react';
import Popup from 'reactjs-popup';
import { translate } from '../../Services/translation';
import { post } from '../../Services/http';

const ConfiguratorSharePopUp = (props) => {
    const [email, setemail] = useState('');
    const [customerMessage, setcustomerMessage] = useState('');
    const [popUpOpen, setpopUpOpen] = useState(false);
    const [showPopup, setshowPopup] = useState(true);
    const [showConfirmationPopup, setshowConfirmationPopup] = useState(false);
    const [emailError, setemailError] = useState(false);

    useEffect(() => {
        setpopUpOpen(true);
        setemailError(false);
    }, []);

    const shareConfiguratorData = () => {
        var emailRegex = /[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,8}(.[a-z{2,8}])?/g;

        if (emailRegex.test(email)) {
            post('api/productconfigurator/saveconfiguratorsharedata', {
                email: email,
                message: customerMessage,
            })
            .then(() => setshowConfirmationPopup(true));
        } else {
            setemailError(true);
        }        
    }

    return (<Fragment>
        {showPopup && <Popup open={popUpOpen} closeOnDocumentClick={false}>
            <div className="configurator__share-popup">
                <div className="modal">
                    <div className="content">
                        <div className="configurator__share-popup--icon"></div>
                        <h3>{showConfirmationPopup ? translate("configuratorShareConfirmationHeader") : props.shareModalHeader}</h3>
                        {showConfirmationPopup ? 
                        <div className='configurator__share-popup-description'>{translate("configuratorShareConfirmationDescription")}</div> 
                        : <div className='configurator__share-popup-description' dangerouslySetInnerHTML={{ __html: props.shareModalDescription }}>
                        </div>}
                        {!showConfirmationPopup ? <div className='row configurator__share-popup-row'>
                            <div className='columns small-6 configurator__share-popup-column'>
                                <label>{translate("configuratorSharePopupEmail")}</label>
                                <div>
                                    <input type='text' onChange={(e) => setemail(e.target.value)}></input>
                                    {emailError && <p className='configurator__share-popup-error'>{translate("configuratorShareEmailError")}</p>}
                                </div>
                                <div dangerouslySetInnerHTML={{ __html: props.shareModalTipsDescription }}></div>
                            </div>
                            <div className='columns small-6 configurator__share-popup-column'>
                                <label>{translate("configuratorSharePopupMessage")}</label>
                                <div>
                                    <textarea type='textarea' onChange={(e) => setcustomerMessage(e.target.value)}></textarea>
                                </div>
                                <div className='button-wrapper button-wrapper-share'>
                                    <a onClick={() => shareConfiguratorData()}>{translate("configuratorSharePopupSend")}</a>
                                </div>
                            </div>
                        </div> : 
                        <div className='button-wrapper button-wrapper-confirmation'>
                            <a onClick={() => { setshowPopup(false); props.hideShareModal(); setpopUpOpen(false);}}>{translate("configuratorShareConfirmationClose")}</a>
                        </div>}
                    </div>
                </div>                
            </div>
        </Popup>}    
        {!showConfirmationPopup && <a className="configurator__share-popup--close" onClick={() => {setshowPopup(false);props.hideShareModal(); 
        setpopUpOpen(false);}}>x</a>}    
    </Fragment>)
}

export default ConfiguratorSharePopUp;